import {
  Facebook,
  Instagram,
  Linkedin,
  MapPin,
  Phone,
  Mail,
  ArrowRight,
} from "lucide-react";
import React, { useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, Link } from "react-router-dom";

const Footer = () => {
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone_no, setPhone] = useState("");

  const [cookies] = useCookies(["token", "user", "id"]);
  const navigate = useNavigate();

  const user_id = cookies.id;

  return (
    <>
      <style>{`
        .luxury-footer {
          background: linear-gradient(135deg, #0f1419 0%, #1a202c 50%, #2d3748 100%);
          color: white;
          padding: 3rem 0 1rem;
          position: relative;
          overflow: hidden;
          border-top: 1px solid rgba(0, 212, 255, 0.2);
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .luxury-footer::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: 
            radial-gradient(circle at 20% 50%, rgba(0, 212, 255, 0.1) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(0, 153, 204, 0.08) 0%, transparent 50%),
            linear-gradient(135deg, rgba(0, 212, 255, 0.03), transparent);
          pointer-events: none;
        }

        .luxury-footer::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #00d4ff, transparent);
          animation: shimmer 3s ease-in-out infinite;
        }

        @keyframes shimmer {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .footer-container {
          max-width: 1400px;
          width: 90%;
          margin: 0 auto;
          padding: 0 2rem;
          position: relative;
          z-index: 2;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1.5fr;
          gap: 3rem;
          margin-bottom: 3rem;
          animation: fadeInUp 0.8s ease-out;
        }

        .footer-section {
          display: flex;
          flex-direction: column;
          animation: fadeInUp 0.8s ease-out;
        }

        .footer-section:nth-child(1) { animation-delay: 0.1s; }
        .footer-section:nth-child(2) { animation-delay: 0.2s; }
        .footer-section:nth-child(3) { animation-delay: 0.3s; }

        .footer-logo {
          max-width: 220px;
          margin-bottom: 1.5rem;
          background: transparent;
          transition: all 0.3s ease;
        }

        .footer-logo:hover {
          transform: scale(1.02);
        }

        .footer-brand-text {
          font-size: 1.6rem;
          font-weight: 700;
          margin-bottom: 1rem;
          background: linear-gradient(135deg, #00d4ff, #0099cc, #00d4ff);
          background-size: 200% 100%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          animation: gradientShift 3s ease-in-out infinite;
          letter-spacing: 0.5px;
        }

        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }

        .footer-description {
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
          margin-bottom: 1rem;
          font-size: 1rem;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .social-links {
          display: flex;
          gap: 1rem;
          margin-top: 0.5rem;
        }

        .social-link {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255, 255, 255, 0.15);
          border-radius: 14px;
          color: white;
          text-decoration: none;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
          z-index: 1;
        }

        .social-link svg {
          position: relative;
          z-index: 2;
          transition: all 0.3s ease;
        }

        .social-link::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #00d4ff, #0099cc);
          transition: left 0.4s ease;
          z-index: 1;
        }

        .social-link:hover::before {
          left: 0;
        }

        .social-link:hover {
          border-color: #00d4ff;
          transform: translateY(-4px) scale(1.05);
          box-shadow: 0 12px 30px rgba(0, 212, 255, 0.4);
          color: white;
        }

        .social-link:hover svg {
          color: white;
          transform: scale(1.1);
        }

        .footer-title {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          color: white;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-link {
          margin-bottom: 0.75rem;
        }

        .footer-link a {
          color: rgba(255, 255, 255, 0.8);
          text-decoration: none;
          font-size: 1rem;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .footer-link a:hover {
          color: #00d4ff;
          transform: translateX(5px);
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          margin-bottom: 1.2rem;
          padding: 1.2rem;
          background: rgba(255, 255, 255, 0.04);
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.08);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }

        .contact-item::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(0, 212, 255, 0.05), rgba(0, 153, 204, 0.03));
          transition: left 0.4s ease;
        }

        .contact-item:hover::before {
          left: 0;
        }

        .contact-item:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(0, 212, 255, 0.4);
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 212, 255, 0.15);
        }

        .contact-icon {
          width: 22px;
          height: 22px;
          color: #00d4ff;
          flex-shrink: 0;
          margin-top: 2px;
          transition: all 0.3s ease;
          filter: drop-shadow(0 2px 4px rgba(0, 212, 255, 0.3));
        }

        .contact-item:hover .contact-icon {
          transform: scale(1.1);
          color: #33e0ff;
        }

        .contact-content {
          flex: 1;
        }

        .contact-label {
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.6);
          margin-bottom: 0.25rem;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .contact-value {
          color: white;
          font-weight: 500;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .contact-value a {
          color: white;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-value a:hover {
          color: #00d4ff;
        }

        .footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          padding-top: 2rem;
          text-align: center;
          position: relative;
        }

        .footer-bottom::before {
          content: '';
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100px;
          height: 1px;
          background: linear-gradient(90deg, transparent, #00d4ff, transparent);
        }

        .footer-copyright {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.95rem;
          margin: 0;
          font-weight: 400;
          letter-spacing: 0.3px;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        @media (max-width: 1200px) {
          .footer-container {
            width: 95%;
            padding: 0 1.5rem;
          }
          
          .footer-grid {
            gap: 2.5rem;
          }
        }

        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 2.5rem;
          }
          
          .footer-section:nth-child(3) {
            grid-column: 1 / -1;
          }
        }

        @media (max-width: 768px) {
          .luxury-footer {
            padding: 2rem 0 1rem;
          }
          
          .footer-container {
            padding: 0 1rem;
            width: 100%;
          }
          
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 2rem;
            margin-bottom: 2rem;
          }
          
          .footer-brand-text {
            font-size: 1.4rem;
            text-align: center;
          }
          
          .footer-description {
            text-align: center;
            font-size: 0.95rem;
          }
          
          .social-links {
            justify-content: center;
          }
          
          .footer-title {
            text-align: center;
            font-size: 1.2rem;
          }
          
          .footer-links {
            text-align: center;
          }
          
          .contact-item {
            padding: 1rem;
            margin-bottom: 1rem;
          }
        }

        @media (max-width: 600px) { 
          .footer-container {
            padding: 0 0.75rem;
          }
          
          .footer-grid {
            gap: 1.5rem;
          }
          
          .footer-brand-text {
            font-size: 1.3rem;
          }
          
          .footer-description {
            font-size: 0.9rem;
          }
          
          .social-links {
            gap: 0.75rem;
          }
          
          .social-link {
            width: 44px;
            height: 44px;
          }
          
          .footer-title {
            font-size: 1.1rem;
            margin-bottom: 1rem;
          }
          
          .footer-link a {
            font-size: 0.9rem;
          }
          
          .contact-item {
            padding: 0.875rem;
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 0.75rem;
          }
          
          .contact-icon {
            margin-top: 0;
          }
        }

        @media (max-width: 480px) {
          .luxury-footer {
            padding: 1.5rem 0 1rem;
          }
          
          .footer-container {
            padding: 0 0.5rem;
          }
          
          .footer-grid {
            gap: 1.25rem;
            margin-bottom: 1.5rem;
          }
          
          .footer-logo {
            max-width: 180px;
            margin: 0 auto 1rem;
          }
          
          .footer-brand-text {
            font-size: 1.2rem;
          }
          
          .footer-description {
            font-size: 0.85rem;
            line-height: 1.5;
          }
          
          .social-links {
            gap: 0.5rem;
          }
          
          .social-link {
            width: 40px;
            height: 40px;
            border-radius: 12px;
          }
          
          .footer-title {
            font-size: 1rem;
            margin-bottom: 0.875rem;
          }
          
          .footer-link {
            margin-bottom: 0.5rem;
          }
          
          .footer-link a {
            font-size: 0.85rem;
            justify-content: center;
          }
          
          .contact-item {
            padding: 0.75rem;
            margin-bottom: 0.75rem;
            border-radius: 12px;
          }
          
          .contact-icon {
            width: 18px;
            height: 18px;
          }
          
          .contact-label {
            font-size: 0.8rem;
          }
          
          .contact-value {
            font-size: 0.85rem;
          }
          
          .footer-bottom {
            padding-top: 1.5rem;
          }
          
          .footer-copyright {
            font-size: 0.8rem;
            line-height: 1.4;
          }
        }

        @media (max-width: 360px) {
          .footer-container {
            padding: 0 0.25rem;
          }
          
          .footer-grid {
            gap: 1rem;
          }
          
          .footer-logo {
            max-width: 160px;
          }
          
          .footer-brand-text {
            font-size: 1.1rem;
          }
          
          .footer-description {
            font-size: 0.8rem;
          }
          
          .social-link {
            width: 36px;
            height: 36px;
          }
          
          .footer-title {
            font-size: 0.95rem;
          }
          
          .footer-link a {
            font-size: 0.8rem;
          }
          
          .contact-item {
            padding: 0.625rem;
            gap: 0.5rem;
          }
          
          .contact-icon {
            width: 16px;
            height: 16px;
          }
          
          .contact-label {
            font-size: 0.75rem;
          }
          
          .contact-value {
            font-size: 0.8rem;
          }
          
          .footer-copyright {
            font-size: 0.75rem;
            padding: 0 0.5rem;
          }
        }
      `}</style>

      <footer className="luxury-footer">
        <div className="footer-container">
          <div className="footer-grid">
            {/* Brand Section */}
            <div className="footer-section">
              <img
                src="/assets/images/Aacoreholiday-logo.png"
                alt="Aacore Holidays Resort"
                className="footer-logo"
              />
              <h3 className="footer-brand-text">Aacore Holidays Resort</h3>
              <p className="footer-description">
                Discover extraordinary destinations and create unforgettable
                memories with our premium travel experiences. Your journey to
                luxury begins here.
              </p>
              <div className="social-links">
                <a
                  href="https://www.instagram.com/aacore_holidays?igsh=MTAxa2h5bDB5aTJzdQ%3D%3D&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <Instagram size={20} />
                </a>
                <a
                  href="https://www.facebook.com/share/1CQcaFQhTt/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <Facebook size={20} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4 className="footer-title">Quick Links</h4>
              <ul className="footer-links">
                <li className="footer-link">
                  <Link to="/">
                    <ArrowRight size={16} /> Home
                  </Link>
                </li>
                <li className="footer-link">
                  <Link to="/about">
                    <ArrowRight size={16} /> About
                  </Link>
                </li>
                <li className="footer-link">
                  <Link to="/travelthemes">
                    <ArrowRight size={16} />
                    Themes
                  </Link>
                </li>
                <li className="footer-link">
                  <Link to="/Services">
                    <ArrowRight size={16} /> Services
                  </Link>
                </li>
                <li className="footer-link">
                  <Link to="/hotel">
                    <ArrowRight size={16} /> Hotels
                  </Link>
                </li>
                <li className="footer-link">
                  <Link to="/ourproduct">
                    <ArrowRight size={16} /> Membership
                  </Link>
                </li>
                <li className="footer-link">
                  <Link to="/contact">
                    <ArrowRight size={16} /> Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Information */}
            <div className="footer-section">
              <h4 className="footer-title">Get In Touch</h4>

              <div className="contact-item">
                <Mail className="contact-icon" />
                <div className="contact-content">
                  <div className="contact-label">General Inquiries</div>
                  <div className="contact-value">
                    <a href="mailto:aacoreholidays@gmail.com">
                      aacoreholidays@gmail.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item">
                <Phone className="contact-icon" />
                <div className="contact-content">
                  <div className="contact-label">Phone</div>
                  <div className="contact-value">
                    <a href="tel:+919898143720">+91 9898143720</a>
                  </div>
                </div>
              </div>

              <div className="contact-item">
                <Mail className="contact-icon" />
                <div className="contact-content">
                  <div className="contact-label">Member Relations</div>
                  <div className="contact-value">
                    <a href="mailto:Info@aacoreholidayresort.com">
                      Info@aacoreholidayresort.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item">
                <Phone className="contact-icon" />
                <div className="contact-content">
                  <div className="contact-label">Member Support</div>
                  <div className="contact-value">
                    <a href="tel:+918866051209">+91 8866051209</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <p className="footer-copyright">
              © 2024 Aacore Holidays Resort Pvt. Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
